import React, { useMemo } from 'react';
import navUpIcon from '../../svg/nav-up.svg';
import navDownIcon from '../../svg/nav-down.svg';
import Button from '../../../../generic-components/Button';
import { useStore } from '../../../../store';
import { ReactComponent as ExitIcon } from '../../../../assets/svg/exit-icon-v2.svg';
import { useClearQueryString } from '../../../../hooks/utilities/useClearQueryString';

export const TransactionDetailsNavigation = () => {
  const transaction = useStore(state => state.selectedTransaction);
  const setSelectedTransaction = useStore(state => state.setSelectedTransaction);
  const handleTransactionNavigation = useStore(state => state.handleTransactionNavigation);
  const { clearQueryString } = useClearQueryString();
  const formattedDate = useMemo(() => {
    const dateParts = new Date(transaction?.timestamp || '').toLocaleString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'UTC',
    }).split(', ');

    const [monthDay, , time] = dateParts;
    const [month, day] = monthDay.split(' ');

    return `${day} ${month} ${dateParts[1]} | ${time}`;
  }, [transaction?.timestamp]);

  const handleNavigate = (isUp: boolean) => {
    handleTransactionNavigation(isUp);
  };
  const handleClose = () => {
    setSelectedTransaction(null);
    clearQueryString();
  };

  return (
    <div className='flex justify-center my-[22px] relative'>
      <Button onClick={handleClose} className='absolute left-0 top-[50%] translate-y-[-50%]' id='closeDrawer' title='' childElement={<ExitIcon className='w-[20px]' />} />
      <div className='flex items-center'>
        <Button
          onClick={() => handleNavigate(true)}
          className=''
          id='paginationUp'
          childElement={
            <img src={navUpIcon} alt='arraow-up' />
              }
        />
        <p className='font-metricR text-bw07 text-[14px] mx-[12px]'>{formattedDate}</p>
        <Button
          onClick={() => handleNavigate(false)}
          className=''
          id='paginationDown'
          childElement={
            <img src={navDownIcon} alt='arraow-down' className='cursor-pointer' />
              }
        />
      </div>
    </div>
  );
};
